// extracted by mini-css-extract-plugin
export default {"component":"LiveSaleIndicator-module__component-ryQN","liveSaleGlow":"LiveSaleIndicator-module__liveSaleGlow-o753","small":"LiveSaleIndicator-module__small-HU1G"};